export const text = {
  themeName: "Sportsbook Light",
};